export default __webpack_public_path__ + "static/media/TVS KING GS+ 4.ffd005d3.webp";